
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/market",
      function () {
        return require("private-next-pages/market.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/market"])
      });
    }
  